<div class="menu-grid container margin-footer">
  <div class="menu-grid-menu">
    <app-todos-config></app-todos-config>
  </div>
  <div>
    <div class="todo-body">
      <app-todo-table [data]="data" [alwaysVisible]="todoAlwaysVisible" (onEditEvent)="getTodos()"></app-todo-table>
    </div>
  </div>
</div>
